import styled from 'styled-components';

import { Button, Text } from '@catalyze/ui';

export const SubscriptionContainer = styled.div`
    display: flex;
    flex-flow: column;
    row-gap: 1.5rem;
    width: 100%;
`;

export const SubscriptionLabel = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    color: ${({ theme }) => theme.colors.fontTertiary};
    margin-bottom: 0.25rem;
`;

export const SubscriptionValue = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const SubscriptionButton = styled(Button)`
    width: 11.5rem;
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;
